import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  // const number = Math.floor(Math.random() * 2) + 1;
  // const imgUrl = number === 1 ? '../../images/nel1.png' : '../../images/nel2.png';

  const skills = [
    'PHP',
    'JavaScript (ES6+)',
    'Symfony',
    'TypeScript',
    'Magento',
    'React.js',
    'Laravel',
    'Python',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              I'm a Software Developer with a <a href="https://nel.sh/wes.badges">Bachelor's degree</a>{' '}
              and over nine (9) years of solid experience writing clean, well-structured code.
              I Specialize in PHP and JavaScript with a strong focus on back-end development
              and some hands-on experiences with front-end technologies such as React and JQuery.
            </p>
            <p>
              Over the years, I’ve had the opportunity to work with companies like{' '}
              <a href="https://nel.sh/ibmbb">Grand hosters</a>,{' '}
              <a href="https://nel.sh/mFUOU">Africabourse</a>,{' '}
              <a href="https://nel.sh/etqqm">Paydunya</a>,{' '}
              <a href="https://nel.sh/m93A7">Lolly Labs Ltd.</a>, and{' '}
              <a href="https://nel.sh/e85IK">LIDD Consultants Inc</a>.,{' '}
              where I focused on building custom Magento 2 modules and back-end solutions for a variety of clients.
            </p>
            <p>
              I'm currently working as a Software Full-Stack Developer at{' '}
              <a href="https://nel.sh/TXCvF" target="_blank" rel="noreferrer">
                Simply Voting Inc.
              </a>, where I contribute to the company's core Symfony application, fixing bugs, modernizing legacy code, and developing new features based on client needs.
            </p>
            <p>Here are a few technologies I’ve been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>


        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/nel2.png"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
